import LocalStorageService from './general/local-storage-service';
import { ActiveStudyCookie, ActiveStudyQuestionCookie } from 'study-types';

const ActiveStudyCacheService = {
  getStudyStateCookie(): ActiveStudyCookie | undefined {
    return LocalStorageService.get('s-state') as unknown as ActiveStudyCookie;
  },

  setStudyStateCookie(data: ActiveStudyCookie): void {
    LocalStorageService.set('s-state', data);
    return;
  },

  resetStudyStateCookie(): void {
    LocalStorageService.delete('s-state');
    return;
  },

  getStudyQuizStateCookie(): ActiveStudyQuestionCookie | undefined {
    return LocalStorageService.get('sq-state') as unknown as ActiveStudyQuestionCookie;
  },

  setStudyQuizStateCookie(data: ActiveStudyQuestionCookie): void {
    LocalStorageService.set('sq-state', data);
    return;
  },

  resetStudyQuizStateCookie(): void {
    LocalStorageService.delete('sq-state');
    return;
  },
};

export default ActiveStudyCacheService;
